import { loadEnv } from '../../shims/load-env';

export const DASHSCOPE_API_KEY_ENV_VARIABLE_NAME = 'DASHSCOPE_API_KEY';
export const DASHSCOPE_DEFAULT_MODEL_ENV_VARIABLE_NAME =
  'DASHSCOPE_DEFAULT_MODEL';

export const DEFAULT_DASHSCOPE_BASE_URL =
  'https://dashscope.aliyuncs.com/compatible-mode/v1';
export const DEFAULT_DASHSCOPE_MODEL = 'qwen3.6-flash';

export function getDefaultDashScopeKey(): string | undefined {
  return loadEnv()[DASHSCOPE_API_KEY_ENV_VARIABLE_NAME];
}

export function getDefaultDashScopeBaseURL(): string {
  return DEFAULT_DASHSCOPE_BASE_URL;
}

export function getDefaultDashScopeModel(): string {
  return (
    loadEnv()[DASHSCOPE_DEFAULT_MODEL_ENV_VARIABLE_NAME] ??
    DEFAULT_DASHSCOPE_MODEL
  );
}
